<template>
  <!-- 讲堂-课堂详情 -->
  <div class="classroomInfoWrap">
      <v-downTip :popShow="popShow" ></v-downTip>
      <v-shareHeader :content="shareSwiper"></v-shareHeader>
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
      <div class="coverImg">
        <img :src="detail.imageAddr" alt="" >        
      </div>
      <div class="classroomData">
        <h1>{{detail.title}}</h1>
        <div class="souce clearfix">
          <div class="headerImgbox">
            <img :src="detail.bigshotHeadImage" alt="" class="headerImg">
          </div>
          <div class="userName">
            <p class="p1">{{detail.bigshotName}}</p>
            <p class="p2">{{detail.createTime}} 阅读 {{detail.readTotal}}</p>
          </div>
          <div style="float:right" v-if="detail.accountId!=$route.query.accountId">
            <div class="follow" v-if="detail.isConcern == 0" @click="toStore()">关注</div>
            <div class="follow isFollow" v-else @click="toStore()">已关注</div>
          </div>
        </div>
        <div class="masterInfoContent" v-html="detail.description"></div>
      </div>
      <!-- 点赞 -->
      <div class="fabulousWrap">
        <div class="fabulous" @click="toStore()"><img src="../images/fabulous.png" alt="">{{detail.fabulousTotal}}</div>       
      </div>
      <!-- 点赞列表 -->
      <div class="fabulousList clearfix">
        <div class="list">
          <div class="imgbox" v-for="item in goodData">
            <img :src="item.headImage?item.headImage:require('../images/headerImg.png')" alt="">
          </div>
        </div>
        <div class="number" @click="toStore">{{detail.fabulousTotal}} 赞过 ></div>
      </div>
      <v-morerepeat :actionId="$route.query.accountId" :shareSwiper="shareSwiper" :isshare="true" :datatype="3"></v-morerepeat>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      detail: '',//页面基础数据
      goodData:'',
      isFabulous:'',
      isFllow:"",
      token:"",
      accountId:"",
      popShow:false,
      shareSwiper:'',
    }
  },
  created(){
    this.init();    
  },
  mounted(){
    weixin.shareInfo(3,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(3,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    init(){
        // this.$http.get("content/classroom/schoolroomDetails?id="+"5a699888f9e89e000144e4e6"+"&accountId=75")
        this.$http.get("content/classroom/schoolroomDetails?id="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
        .then((response) => {
          this.detail = response.respData;
          this.goodData = this.detail.fabulousList;
          this.isFabulous = this.detail.isPraise;
          this.isFllow = response.respData.isConcern;
          this.accountId=response.respData.accountId;
        })
        .catch((response) => {
        });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.classroomInfoWrap{
  width: 100%;
  margin: 88px 0;
  height: auto;
  .coverImg{
    width: 100%;
    height: 5.6rem;
    margin-bottom: 0.43rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
  .classroomData{
    padding: 0 0.4rem;
    h1{
      line-height: 0.75rem;
      font-size: 0.53rem;
      color: #333440;
      font-weight: bold;
      margin-bottom: 0.27rem;
    }
    .souce{
      font-size: 0.32rem;
      color: #A4A4A4;
      margin-bottom: 0.37rem;
      line-height: 0.91rem;
      .headerImgbox{
        width: .91rem;
        height: .91rem;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        vertical-align: middle;
        float: left;
      }
      .headerImg{
        max-width: 100%;
        max-height: 100%;
      }
      .userName{
        display: inline-block;
        font-size: 0.32rem;
        color: #333440;
        vertical-align: middle;        
        margin-left: 0.27rem;
        .p1{
          font-size: 0.37rem;
          color: #BA9E70;
          line-height: 0.53rem;          
        }
        .p2{
          font-size: 0.29rem;
          color: #A4A4A4;
          line-height: 0.43rem;
        }
      }
      .follow{
        float: right;
        width: 1.6rem;
        height: 0.72rem;
        background-image: linear-gradient(-270deg, #EF4B4B 4%, #F7643C 100%);
        box-shadow: 0 0.08rem 0.16rem 0 rgba(239,75,75,0.30);
        border-radius: 2.67rem;
        text-align: center;
        line-height: 0.72rem;
        color: #fff;
        font-size: 0.32rem;
        margin-top: 0.1rem;
      }
      .isFollow{
        background: #FFF1EF;
        color: #E27574;
        background-image: none;
        box-shadow: none;
      }
    }
  }
  
  .fabulousWrap{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.8rem 0 ;
    .fabulous{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.73rem;
      height: 0.96rem;
      line-height: 0.96rem;
      border: 0.03rem solid #D1D1D1;
      border-radius: 2.67rem;
      text-align: center;
      font-size: 0.29rem;
      color: #A4A4A4;
      img{
        width: 0.59rem;
        height: 0.53rem;
        margin-right: 0.05rem;
      }
    }
    .not{
      img{
        width: 0.69rem;
        height: 0.64rem;
      }
    }
  }
  .fabulousList{
    height: 1.28rem;
    line-height: 1.28rem;
    border-top: 0.03rem solid #EFEFEF;
    border-bottom: 0.03rem solid #EFEFEF;
    padding: 0 0.32rem 0 0.4rem;
    .list{
      .imgbox{
          display: flex;
          float: left;
          justify-content: center;
          -ms-flex-align: center;
          align-items: center;
          width: .69rem;
          height: .69rem;
          border-radius: 100%;
          margin-top: .266667rem;
          margin-right: .16rem;
          overflow: hidden;
        img{
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .number{
      float: right;
      font-size: 0.29rem;
      color: #A4A4A4;
    }
  }
}

</style>
<style lang="less">
  .masterInfoContent{
    width:100%;
    overflow: hidden;
    font-size:32px;
    img,video,table{
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/share/sharechassroomInfo.vue